import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img.bb9c4fe3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7ad335fe"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "SSheet"
};
var _hoisted_2 = {
  class: "SSheet-box"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "Sheet-item-left"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = {
  class: "song-count"
};
var _hoisted_8 = {
  class: "creator-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 歌单item项 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheetList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "Sheet-item",
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.sheetClick(item.id);
      }
    }, [_createElementVNode("div", _hoisted_4, [_createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      src: item.coverImgUrl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_5];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createCommentVNode(" 歌单名 "), _createElementVNode("span", {
      class: "sheet-name linelittle",
      innerHTML: _ctx.lightKeyword(item.name, _ctx.inputValue)
    }, null, 8
    /* PROPS */
    , _hoisted_6)]), _createCommentVNode(" 曲目数 "), _createElementVNode("span", _hoisted_7, _toDisplayString(item.trackCount) + "首", 1
    /* TEXT */
    ), _createCommentVNode(" 创建者 "), _createElementVNode("span", _hoisted_8, _toDisplayString(item.creator.nickname), 1
    /* TEXT */
    )], 8
    /* PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]);
}